import {
    projectsScopeProjectsSelector,
    projectsScopeGroupsSelector,
    projectsScopeLoadingSelector,
    projectsScopeSelectedNamesSelector,
    isEmptySelector
} from '../../selectors/projects-scope';

export default class ProjectsScopeController {
    static $inject = ['$scope','$ngRedux','SelectedActions'];
    constructor($scope, $ngRedux, SelectedActions) {
        'ngInject';
        this.$scope = $scope;
        this.unsubscribe = $ngRedux.connect(mapStateToThis, { select: SelectedActions.select })(this);
        this.searchText = '';
    }

    $onDestroy() {
        this.unsubscribe();
    }

    apply(open) {
        if (!open) {
            const projects = this.projects.filter(p => p.isSelected).map(p => p.id);
            const groups = this.groups.filter(g => g.isSelected).map(g => (g.id));
            this.select({ projects, groups });
        }
        this.searchText = '';
    }

    toggle(item) {
        item.isSelected = !item.isSelected;
    }

    getSortedProjects(){
        if(this.projects && this.projects.length>0){
            return this.projects.sort(this.projectsSortByDateComparator);
        }
        return [];
    }

    projectsSortByDateComparator(proj1,proj2){
        if (proj1.isDraft && proj2.isDraft == false) {
            return 1;
        } else if (proj1.isDraft == false && proj2.isDraft) {
            return -1;
        }

        if (proj1.lastActivity != null && proj2.lastActivity != null) {
            let firstDate = new Date(proj1.lastActivity);
            let secondDate = new Date(proj2.lastActivity);
            if (firstDate.getTime() > secondDate.getTime()) {
                return -1;
            } else if (firstDate.getTime() < secondDate.getTime()) {
                return 1;
            } else {
                 return 0;
            }
        }

        if (proj1.lastActivity != null && proj2.lastActivity == null) {
            return -1;
        }
        if (proj1.lastActivity == null && proj2.lastActivity != null) {
            return 1;
        }

        return proj1.name.localeCompare(proj2.name);
    }

    get label() {
        if (this.selectedNames) {
            return this.selectedNames;
        } else if (this.loading) {
            return 'Loading...';
        } else if (this.isEmpty) {
            return 'Nothing was found';
        } else {
            return 'Select Projects';
        }
    }
}

function mapStateToThis(state) {
    const obj = {
        projects: projectsScopeProjectsSelector(state),
        groups: projectsScopeGroupsSelector(state),
        loading: projectsScopeLoadingSelector(state),
        selectedNames: projectsScopeSelectedNamesSelector(state),
        isEmpty: isEmptySelector(state)
    };
    return obj;
}



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/projecs-scope/projects-scope.controller.js